export default __webpack_public_path__ + "static/media/about.0e1ea958.jpg";